// ##################################### IMPORT PART
import React, { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import debounce from "lodash/debounce";
import GlobalStyle from './GlobalStyle';
// ####################################  END IMPORT PART



// ######################################### STYLES BUTTON ECC
const FormContainer = styled.div`
  background-color: #fff9c4; /* giallo chiaro */
  max-width: 600px;
  margin: auto;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: relative;
`;
const Input = styled.input`
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 4px;
`;
const Button = styled.button`
  width: 100%;
  padding: 10px;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 10px;
  &:hover {
    background: #218838;
  }
`;
const ListContainer = styled.ul`
  margin-top: -5px; /* poco margine se serve */
  border: 1px solid #ccc;
  padding: 0;
  list-style: none;
  max-height: 200px;
  overflow-y: auto;
  background: white;
  width: 100%;
  border-radius: 4px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
`;
const ListItem = styled.li`
  padding: 10px;
  cursor: pointer;
  background: #f9f9f9;
  border-bottom: 1px solid #ddd;
  &:hover {
    background: #e0e0e0;
  }
`;
const Select = styled.select`
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 4px;
`;
const QuantityContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;
const QuantityInput = styled(Input)`
  width: 70%;
`;
const UnitSelect = styled(Select)`
  width: 30%;
  margin-left: 10px;
`;
const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;
// ################################################################################## END STYLES BUTTON ECC

// ############################################################# COMPONENT
const AddProduct = ({ existingOrderId = null, initialFormattedOrderId = null, returnToEditProducts = false }) => {
 const navigate = useNavigate();
 const [formattedOrderId, setFormattedOrderId] = useState(initialFormattedOrderId || "");
 const [orderId, setOrderId] = useState("");
 const [productName, setProductName] = useState("");
 const [code, setCode] = useState("");
 const [quantity, setQuantity] = useState("");
 const [filteredProducts, setFilteredProducts] = useState([]);
 const [filteredCustomers, setFilteredCustomers] = useState([]);
 const [loading, setLoading] = useState(false);
 const [setNoResults] = useState(false);
 const [showProductList, setShowProductList] = useState(false);
 const [showCustomerList, setShowCustomerList] = useState(false);
 const [unit, setUnit] = useState("");
 const [unitOptions, setUnitOptions] = useState([]);
 const [customer, setCustomer] = useState("");
 const [orderDate, setOrderDate] = useState(new Date().toISOString());
 const [isFirstProduct, setIsFirstProduct] = useState(!existingOrderId);
 const dropdownRef = useRef(null);
 const [purchasePrice, setPurchasePrice] = useState(null);
 const [salePrices, setSalePrices] = useState([]);
 const [products, setProducts] = useState([]);
 const [alternativeQuantity, setAlternativeQuantity] = useState("");
 const [productsToEdit, setProductsToEdit] = useState([]);
 const [currentProductIndex, setCurrentProductIndex] = useState(0);
 const [ritiroInsede, setRitiroInsede] = useState(false);
 const [lotto, setLotto] = useState('');
 const [IdForSearch, setIdForSearch] = useState("");

useEffect(() => { if (existingOrderId && !formattedOrderId) { setFormattedOrderId(existingOrderId); } }, [existingOrderId, formattedOrderId]);

// ##################### AddProducts
const handleAddProduct = async () => {
  if (!productName || !code) {
    return alert("Please enter all product details.");
  }
  if (isFirstProduct && (!customer || !orderDate)) {
    return alert("Please enter customer and order date.");
  }
  const onlyDate = orderDate.includes("T") ? orderDate.split("T")[0] : orderDate;
  const generatedId = `${customer.trim()} - ${onlyDate}`;

// CREA ORDINE SE NECESSARIO
if (isFirstProduct) {
  try {
   await axios.post("/api/NewBollareso", {
    orderId: generatedId, customer, orderDate});
    setFormattedOrderId(generatedId);
    setOrderId(generatedId);
    setIsFirstProduct(false);
  } catch (error) {
    console.error("Error creating order:", error);
    return;
  }
}

// ###### DETERMINA ID CORRETTO
const orderToUse = formattedOrderId || generatedId;
try {
  await axios.post(`/api/bollereso/${orderToUse}/products`,
    { quantity: parseFloat(quantity), unit, customer, orderDate, code, lotto, CAUSALE: "RESFO"});

// Successivo prodotto o reset
if (productsToEdit.length > 0 && currentProductIndex < productsToEdit.length - 1) {
  setCurrentProductIndex(currentProductIndex + 1);
 } else {
  setProductsToEdit([]); setCurrentProductIndex(0); setQuantity(""); setUnit(""); setCode(""); setFilteredProducts([]); setShowProductList(false); setLotto(""); setProductName(""); }
  } catch (error) {
    console.error("Error adding product:", error);
  }
};
// ######################################################

// Debounced fornitori
const fetchFilteredCustomers = useCallback(
  debounce(async (filter) => {
    if (!filter) {
      setFilteredCustomers([]);
      setShowCustomerList(false);
      return;
    }
    setLoading(true);
    try {
      const { data } = await axios.get(
        `/api/fornitori?filter=${filter}`
      );
      setFilteredCustomers(data);
      setShowCustomerList(Boolean(data.length));
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, 500),
  [IdForSearch]
);
// ##########################################################


// Popola subito customer per filtrare prodotti già acquistati
const generateIdForSearch = (cust, date) => {
  if (!cust || !date) return "";
  const normalizedCustomer = cust.trim().replace(/\s+/g, " ");
  return `${normalizedCustomer} - ${date}`;
};

useEffect(() => {
  const newId = generateIdForSearch(customer, orderDate);
  setIdForSearch(newId);
}, [customer, orderDate]);
useEffect(() => {
}, [IdForSearch]);


// Debounce Prodotti
const fetchFilteredProducts = useCallback(
  debounce(async (filter, idSearch) => {
    if (!filter) {
      setFilteredProducts([]);
      setShowProductList(false);
      return;
    }
    setLoading(true);
    try {
      const { data } = await axios.get(
        `/api/products?filter=${filter}&IdForSearch=${idSearch}`
      );
      if (data.length) {
        const sorted = [...data].sort((a, b) => {
          if (a.source === 'internal' && b.source !== 'internal') return -1;
          if (a.source !== 'internal' && b.source === 'internal') return 1;
          return 0;
        });
     const combined = sorted.map(p => {
      const code = (p.code || p.productCode || "").trim();
      const name = (p.productName || "").trim();
      const ARUNMIS1 = (p.ARUNMIS1 || "").trim();
      const ARUNMIS2 = (p.ARUNMIS2 || "").trim();
      let dateInfo = "";
       if (p.source === "internal" && p.date) {
      dateInfo = ` (${p.date})`;
      }
        return {
          ...p,
          ARCODART: code,
          ARDESART: name,
          ARUNMIS1: ARUNMIS1,
          ARUNMIS2: ARUNMIS2,
          combinedDescription: `${code} ${name} ${dateInfo}`,
          cleanDescription: `${code} ${name}`
        };
      });
      setFilteredProducts(combined);
      const firstInternal = combined.find(p => p.source === 'internal');
      }
      } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, 500),
  [IdForSearch]
);
// ################################################################################

// Logica per ordini già esistenti
useEffect(() => {
if (existingOrderId) {
  axios
    .get(`/api/bollereso/${existingOrderId}`)
  .then((res) => {
    const order = res.data;
    console.log("Risposta ordine esistente:", order);
    if (order.products && order.products.length > 0) {
      const productData = order.products[0];
      const parsedProducts = productData.products
        ? (typeof productData.products === 'string' ? JSON.parse(productData.products) : productData.products)
        : [];
      setOrderId(order.orderId);
      setCustomer(parsedProducts[0]?.customer?.trim() || "");
      setOrderDate(order.orderDate);
      setProducts(parsedProducts);
      setProductsToEdit(parsedProducts);
      setIsFirstProduct(false);
      setCurrentProductIndex(0);
    } else {
      console.error("Ordine non trovato o prodotti assenti.");
    }
  })
  .catch((err) =>
    console.error("Errore caricamento ordine esistente:", err)
  );


// intercetta click fuori da dropdown
const handleClickOutside = e => {
  if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
   setShowProductList(false);
   setShowCustomerList(false);
  }
};
document.addEventListener("mousedown", handleClickOutside);
return () => {document.removeEventListener("mousedown", handleClickOutside);};}
}, [existingOrderId]);
// ##############################################


// termina e salva ordine
const handleFinish = async () => {
  try {
    alert("✅ Order completed.");
    if (returnToEditProducts) {
      const url = `/bollereso-edit-products/${orderId}`;
      window.location.href = url;
    } else {
      navigate("/BolleresoEdit");
    }
  } catch (error) {
    console.error("Errore nel completare l'ordine:", error);
    alert("❌ Errore nel completare l'ordine");
  }
};
// ######################################################################################################################

// RETURN
return (
  <>
    <GlobalStyle />
    <FormContainer ref={dropdownRef}>
      <h4>Aggiungi/modifica prodotto a Bolla di reso {orderId}</h4>

      {isFirstProduct && (
        <>
          <label>Fornitore:</label>
          <Input
            value={customer}
            onChange={(e) => {
              setCustomer(e.target.value);
              fetchFilteredCustomers(e.target.value);
            }}
            onFocus={() => setShowCustomerList(true)}
            placeholder="Cerca fornitore"
          />
          {showCustomerList && (
            <ListContainer>
              {filteredCustomers.map((c) => (
                <ListItem
                  key={c.ANDCODICE}
                  onClick={() => {
                    setCustomer(c.ANDESCRI);
                    setShowCustomerList(false);
                  }}
                >
                  {c.ANDESCRI}
                </ListItem>
              ))}
            </ListContainer>
          )}
        </>
      )}

      <label>Product Name:</label>
      <Input
        value={productName}
        onChange={(e) => {
         const val = e.target.value;
         setProductName(val);
         fetchFilteredProducts(val, IdForSearch);
         if (val.trim().length > 3) {
          setShowProductList(true);
         } else {
          setShowProductList(false);
         }
        }}
      />
      {showProductList && (
        <ListContainer>
          {filteredProducts.map((p) => (
            <ListItem
              key={p.ARCODART}
              onClick={() => {
                setCode(p.ARCODART);
                setProductName(p.cleanDescription);
                setUnitOptions([p.ARUNMIS1, p.ARUNMIS2].filter(Boolean));
                setUnit(p.ARUNMIS1 || p.ARUNMIS2 || "");
                setShowProductList(false);
              }}
              style={{
                fontWeight: p.source === "internal" ? "bold" : "normal",
                backgroundColor: p.source === "internal" ? "#e6f7ff" : "transparent",
                padding: "6px 10px",
                cursor: "pointer",
              }}
            >
              {p.combinedDescription}
            </ListItem>
          ))}
        </ListContainer>
      )}

      <label>Quantità sistema:</label>
      <QuantityContainer>
        <QuantityInput
          type="number"
          value={quantity}
          onChange={(e) => setQuantity(e.target.value)}
        />
        <UnitSelect value={unit} onChange={(e) => setUnit(e.target.value)}>
          {unitOptions.map((opt, i) => (
            <option key={i} value={opt}>
              {opt}
            </option>
          ))}
        </UnitSelect>
      </QuantityContainer>

      <label style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
        Lotto:
        <input
          type="text"
          value={lotto}
          onChange={(e) => {
            const val = e.target.value.toUpperCase();
            if (val.length <= 6) setLotto(val);
          }}
          maxLength={8}
          style={{
            width: "100px",
            padding: "4px 8px",
            borderRadius: "4px",
            border: "1px solid #ccc",
          }}
        />
      </label>

      <Button onClick={handleAddProduct}>Aggiungi prodotto</Button>
      <Button
        onClick={() => {
          handleAddProduct();
          handleFinish();
        }}
      >
        Aggiungi prodotto e termina ordine
      </Button>
    </FormContainer>
  </>
);
};

export default AddProduct;
